import { SEVERITY_META, SEVERITY_RANK } from '../constants/severities.js';

/** Metadata (label key, color classes) for a severity, with a safe fallback. */
export function getSeverityMeta(severity) {
  return SEVERITY_META[severity] ?? SEVERITY_META.action;
}

/** Numeric rank for sorting (lower = more urgent). */
export function getSeverityRank(severity) {
  return SEVERITY_RANK[severity] ?? Number.MAX_SAFE_INTEGER;
}
